export const deleteActivityFromSequence = (sequence, activityId) => {
  const beg = sequence.findIndex(seq => seq.activity === activityId);
  const numberItems = sequence.filter( seq => seq.activity === activityId).length;
  sequence.splice(beg, numberItems);
  return sequence;
}
